import React from "react";
import BaseModal from "./BaseModal";

/**
 * AssignModal Component
 * Modal for assigning diagnostics to employees or roles
 * Props:
 * - isOpen: Boolean to control visibility
 * - onClose: Callback when modal should close
 * - onConfirm: Callback when assignment is confirmed
 * - title: Modal title
 * - options: Array of options for the dropdown { value, label }
 * - selectLabel: Label for the select field
 * - selectPlaceholder: Placeholder text for select
 * - selectedValue: Current selected value
 * - onSelectChange: Callback when selection changes
 */
export default function AssignModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Assign Diagnostic Form",
  options = [],
  selectLabel = "Staff assign",
  selectPlaceholder = "Select",
  selectedValue = "",
  onSelectChange,
}) {
  const footer = (
    <>
      <button
        className="cd-modal-btn cd-modal-btn-cancel"
        onClick={onClose}
      >
        Cancel
      </button>
      <button
        className="cd-modal-btn cd-modal-btn-confirm"
        onClick={onConfirm}
      >
        Confirm & Assign →
      </button>
    </>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={footer}
    >
      <div className="cd-modal-field">
        <label className="cd-modal-label">
          {selectLabel}
        </label>
        <select
          className="cd-modal-select"
          value={selectedValue}
          onChange={(e) => onSelectChange?.(e.target.value)}
        >
          <option value="">{selectPlaceholder}</option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </BaseModal>
  );
}
